// extracted by mini-css-extract-plugin
module.exports = {"notice":"update-catalogue-modal_notice_2a6Lh","buttonWrap":"update-catalogue-modal_buttonWrap_1z5pS","button":"update-catalogue-modal_button_1EBrx"};